import { useParams, useNavigate, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";

import {
    FaMapMarkerAlt,
    FaArrowRight,
    FaHotel,
    FaStar,
    FaCheck,
    FaChevronRight,
    FaCompass,
    FaShieldAlt,
} from "react-icons/fa";

import Header from "../components/Header";
import Footer from "../components/Footer";
import Hero from "../components/Hero";
import heroImg from "../assests/images/hero.jpg";

export default function DestinationDetails() {
    const { slug } = useParams();
    const navigate = useNavigate();

    const [destination, setDestination] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchDestination = async () => {
            try {
                const res = await axios.get(
                    `https://marinadubai.com/api/destinations/${slug}`
                );

                setDestination(res.data);
            } catch (err) {
                console.error("Failed to fetch destination:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchDestination();
    }, [slug]);

    /* =====================================================
       LOADING
    ===================================================== */

    if (loading) {
        return (
            <div className="min-h-screen bg-[#F7F5EF]">
                <Header />

                <div className="flex min-h-[70vh] items-center justify-center px-5">
                    <div className="text-center">

                        <div
                            className="
                                mx-auto
                                h-12
                                w-12
                                animate-spin
                                rounded-full
                                border-4
                                border-[#DED8CC]
                                border-t-[#0B5552]
                            "
                        />

                        <p
                            className="
                                mt-5
                                text-[11px]
                                font-semibold
                                uppercase
                                tracking-[0.16em]
                                text-[#687572]
                            "
                        >
                            Loading destination...
                        </p>

                    </div>
                </div>

                <Footer />
            </div>
        );
    }

    /* =====================================================
       NOT FOUND
    ===================================================== */

    if (!destination) {
        return (
            <div className="min-h-screen bg-[#F7F5EF]">
                <Header />

                <div className="flex min-h-[70vh] items-center justify-center px-5">

                    <div className="max-w-md text-center">

                        <div
                            className="
                                mx-auto
                                flex
                                h-20
                                w-20
                                items-center
                                justify-center
                                rounded-full
                                border
                                border-[#DED8CC]
                                bg-[#F3EBDD]
                            "
                        >
                            <FaCompass className="text-2xl text-[#0B5552]" />
                        </div>

                        <div
                            className="
                                mx-auto
                                mt-6
                                flex
                                items-center
                                justify-center
                                gap-3
                            "
                        >
                            <span className="h-px w-7 bg-[#D5A33C]" />

                            <span
                                className="
                                    text-[10px]
                                    font-semibold
                                    uppercase
                                    tracking-[0.22em]
                                    text-[#0B5552]
                                "
                            >
                                Dubai Hotel Rates
                            </span>

                            <span className="h-px w-7 bg-[#D5A33C]" />
                        </div>

                        <h1
                            className="
                                mt-4
                                font-serif
                                text-[34px]
                                font-medium
                                leading-tight
                                tracking-[-0.02em]
                                text-[#173F3E]
                            "
                        >
                            Destination Not Found
                        </h1>

                        <p
                            className="
                                mt-4
                                text-[13px]
                                leading-6
                                text-[#687572]
                            "
                        >
                            We couldn't find the destination you're looking
                            for. Please explore our other Dubai destinations.
                        </p>

                        <button
                            onClick={() => navigate("/destinations")}
                            className="
                                mt-7
                                inline-flex
                                items-center
                                gap-2
                                rounded-xl
                                bg-[#0B5552]
                                px-6
                                py-3.5
                                text-[12px]
                                font-bold
                                text-white
                                shadow-[0_10px_25px_rgba(11,85,82,0.18)]
                                transition-all
                                duration-300
                                hover:-translate-y-0.5
                                hover:bg-[#073F3D]
                                hover:shadow-[0_15px_30px_rgba(11,85,82,0.22)]
                            "
                        >
                            Explore Destinations
                            <FaArrowRight className="text-[11px]" />
                        </button>

                    </div>
                </div>

                <Footer />
            </div>
        );
    }

    const hotels = destination.hotels || [];

    return (
        <div
            className="
                min-h-screen
                bg-[#F7F5EF]
                text-[#173F3E]
            "
        >

            {/* =====================================================
                HERO
            ===================================================== */}

            <section className="relative overflow-hidden">

                <Hero
                    heightClass="h-[300px] sm:h-[330px] md:h-[370px] lg:h-[410px]"
                    title={destination.name}
                    backgroundImage={heroImg}
                    contentClass=""
                />

                {/* HERO OVERLAY */}

                <div
                    className="
                        pointer-events-none
                        absolute
                        inset-0
                        bg-gradient-to-b
                        from-[#073F3D]/10
                        via-transparent
                        to-[#073F3D]/30
                    "
                />

                {/* BREADCRUMB */}

                <div className="absolute bottom-5 left-0 right-0 z-20 sm:bottom-7">

                    <div
                        className="
                            mx-auto
                            max-w-[1440px]
                            px-5
                            sm:px-8
                            lg:px-12
                            xl:px-16
                        "
                    >

                        <div
                            className="
                                inline-flex
                                items-center
                                gap-2
                                rounded-full
                                border
                                border-white/20
                                bg-[#073F3D]/80
                                px-4
                                py-2.5
                                text-[10px]
                                font-medium
                                text-white
                                shadow-lg
                                backdrop-blur-md
                            "
                        >

                            <Link
                                to="/"
                                className="
                                    transition-colors
                                    hover:text-[#E5C56D]
                                "
                            >
                                Home
                            </Link>

                            <FaChevronRight
                                className="text-[7px] text-white/40"
                            />

                            <Link
                                to="/destinations"
                                className="
                                    transition-colors
                                    hover:text-[#E5C56D]
                                "
                            >
                                Destinations
                            </Link>

                            <FaChevronRight
                                className="text-[7px] text-white/40"
                            />

                            <span className="font-semibold text-[#E5C56D]">
                                {destination.name}
                            </span>

                        </div>

                    </div>
                </div>

            </section>


            {/* =====================================================
                DESTINATION INTRO
            ===================================================== */}

            <section
                className="
                    relative
                    z-10
                    -mt-10
                    px-5
                    sm:px-8
                    lg:px-12
                    xl:px-16
                "
            >

                <div className="mx-auto max-w-[1440px]">

                    <div
                        className="
                            overflow-hidden
                            rounded-[22px]
                            border
                            border-[#DED8CC]
                            bg-[#FBFAF6]
                            shadow-[0_18px_55px_rgba(15,45,44,0.08)]
                        "
                    >

                        <div className="grid lg:grid-cols-[1fr_260px]">

                            {/* =================================================
                                CONTENT
                            ================================================= */}

                            <div className="p-6 sm:p-8 lg:p-11">

                                {/* LABELS */}

                                <div className="flex flex-wrap items-center gap-2.5">

                                    <span
                                        className="
                                            inline-flex
                                            items-center
                                            gap-2
                                            rounded-full
                                            border
                                            border-[#D5A33C]/30
                                            bg-[#F3EBDD]
                                            px-3
                                            py-1.5
                                            text-[9px]
                                            font-bold
                                            uppercase
                                            tracking-[0.14em]
                                            text-[#0B5552]
                                        "
                                    >
                                        <FaMapMarkerAlt className="text-[10px]" />
                                        Dubai Destination
                                    </span>

                                    <span
                                        className="
                                            inline-flex
                                            items-center
                                            gap-2
                                            rounded-full
                                            border
                                            border-[#DED8CC]
                                            bg-white
                                            px-3
                                            py-1.5
                                            text-[9px]
                                            font-bold
                                            uppercase
                                            tracking-[0.12em]
                                            text-[#B78932]
                                        "
                                    >
                                        <FaHotel className="text-[10px]" />
                                        {hotels.length} Hotels
                                    </span>

                                </div>


                                {/* HEADING */}

                                <h1
                                    className="
                                        mt-5
                                        font-serif
                                        text-[31px]
                                        font-medium
                                        leading-[1.08]
                                        tracking-[-0.02em]
                                        text-[#173F3E]

                                        sm:text-[38px]

                                        lg:text-[44px]
                                    "
                                >
                                    Hotels in{" "}
                                    <span
                                        className="
                                            italic
                                            text-[#B78932]
                                        "
                                    >
                                        {destination.name}
                                    </span>
                                </h1>


                                {/* DESCRIPTION */}

                                <p
                                    className="
                                        mt-4
                                        max-w-3xl
                                        text-[12px]
                                        leading-6
                                        text-[#687572]

                                        sm:text-[13px]
                                    "
                                >
                                    Discover comfortable and carefully selected
                                    hotels in {destination.name}. Compare
                                    accommodation options, explore hotel
                                    facilities and find the perfect stay for
                                    your Dubai trip.
                                </p>


                                {/* TRUST ITEMS */}

                                <div className="mt-7 flex flex-wrap gap-x-7 gap-y-4">

                                    {/* ITEM 1 */}

                                    <div className="flex items-center gap-2.5">

                                        <div
                                            className="
                                                flex
                                                h-9
                                                w-9
                                                items-center
                                                justify-center
                                                rounded-full
                                                border
                                                border-[#D5A33C]/30
                                                bg-[#F3EBDD]
                                            "
                                        >
                                            <FaCheck className="text-[11px] text-[#0B5552]" />
                                        </div>

                                        <div>
                                            <p
                                                className="
                                                    text-[11px]
                                                    font-bold
                                                    text-[#173F3E]
                                                "
                                            >
                                                Best Hotel Deals
                                            </p>

                                            <p
                                                className="
                                                    mt-0.5
                                                    text-[9px]
                                                    text-[#89928F]
                                                "
                                            >
                                                Competitive rates
                                            </p>
                                        </div>

                                    </div>


                                    {/* ITEM 2 */}

                                    <div className="flex items-center gap-2.5">

                                        <div
                                            className="
                                                flex
                                                h-9
                                                w-9
                                                items-center
                                                justify-center
                                                rounded-full
                                                border
                                                border-[#D5A33C]/30
                                                bg-[#F3EBDD]
                                            "
                                        >
                                            <FaShieldAlt className="text-[11px] text-[#B78932]" />
                                        </div>

                                        <div>
                                            <p
                                                className="
                                                    text-[11px]
                                                    font-bold
                                                    text-[#173F3E]
                                                "
                                            >
                                                Trusted Booking
                                            </p>

                                            <p
                                                className="
                                                    mt-0.5
                                                    text-[9px]
                                                    text-[#89928F]
                                                "
                                            >
                                                Secure reservation
                                            </p>
                                        </div>

                                    </div>


                                    {/* ITEM 3 */}

                                    <div className="flex items-center gap-2.5">

                                        <div
                                            className="
                                                flex
                                                h-9
                                                w-9
                                                items-center
                                                justify-center
                                                rounded-full
                                                border
                                                border-[#D5A33C]/30
                                                bg-[#F3EBDD]
                                            "
                                        >
                                            <FaHotel className="text-[11px] text-[#0B5552]" />
                                        </div>

                                        <div>
                                            <p
                                                className="
                                                    text-[11px]
                                                    font-bold
                                                    text-[#173F3E]
                                                "
                                            >
                                                Quality Stays
                                            </p>

                                            <p
                                                className="
                                                    mt-0.5
                                                    text-[9px]
                                                    text-[#89928F]
                                                "
                                            >
                                                Selected hotels
                                            </p>
                                        </div>

                                    </div>

                                </div>

                            </div>


                            {/* =================================================
                                HOTEL COUNT
                            ================================================= */}

                            <div
                                className="
                                    flex
                                    min-h-[190px]
                                    items-center
                                    justify-center
                                    border-t
                                    border-[#DED8CC]
                                    bg-[#F3EBDD]
                                    p-8

                                    lg:border-l
                                    lg:border-t-0
                                "
                            >

                                <div className="text-center">

                                    <div
                                        className="
                                            mx-auto
                                            flex
                                            h-[70px]
                                            w-[70px]
                                            items-center
                                            justify-center
                                            rounded-full
                                            border
                                            border-[#D5A33C]/40
                                            bg-[#0B5552]
                                            shadow-[0_10px_25px_rgba(11,85,82,0.18)]
                                        "
                                    >
                                        <FaHotel className="text-2xl text-[#E5C56D]" />
                                    </div>

                                    <p
                                        className="
                                            mt-4
                                            font-serif
                                            text-[34px]
                                            font-medium
                                            leading-none
                                            text-[#173F3E]
                                        "
                                    >
                                        {hotels.length}
                                    </p>

                                    <p
                                        className="
                                            mt-2
                                            text-[9px]
                                            font-semibold
                                            uppercase
                                            tracking-[0.18em]
                                            text-[#687572]
                                        "
                                    >
                                        Available Hotels
                                    </p>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </section>


            {/* =====================================================
                HOTELS SECTION
            ===================================================== */}

            <section
                className="
                    px-5
                    py-16

                    sm:px-8
                    sm:py-18

                    lg:px-12
                    lg:py-20

                    xl:px-16
                "
            >

                <div className="mx-auto max-w-[1440px]">

                    {/* =================================================
                        SECTION INTRO
                    ================================================= */}

                    <div
                        className="
                            mb-10
                            flex
                            flex-col
                            gap-5

                            lg:mb-12
                            lg:flex-row
                            lg:items-end
                            lg:justify-between
                        "
                    >

                        <div>

                            <div
                                className="
                                    mb-3
                                    flex
                                    items-center
                                    gap-3
                                "
                            >
                                <span
                                    className="
                                        h-[1px]
                                        w-8
                                        bg-[#D5A33C]
                                    "
                                />

                                <span
                                    className="
                                        text-[10px]
                                        font-semibold
                                        uppercase
                                        tracking-[0.22em]
                                        text-[#0B5552]
                                    "
                                >
                                    Explore Your Options
                                </span>
                            </div>

                            <h2
                                className="
                                    font-serif
                                    text-[30px]
                                    font-medium
                                    leading-[1.08]
                                    tracking-[-0.02em]
                                    text-[#173F3E]

                                    sm:text-[36px]

                                    lg:text-[42px]
                                "
                            >
                                Find Your{" "}
                                <span className="italic text-[#B78932]">
                                    Perfect Stay
                                </span>
                            </h2>

                        </div>


                        <p
                            className="
                                max-w-[440px]
                                text-[12px]
                                leading-6
                                text-[#687572]

                                sm:text-[13px]

                                lg:text-right
                            "
                        >
                            Browse our selection of hotels in{" "}
                            <span className="font-semibold text-[#0B5552]">
                                {destination.name}
                            </span>{" "}
                            and choose the stay that suits your trip.
                        </p>

                    </div>


                    {/* =================================================
                        HOTEL GRID
                    ================================================= */}

                    {hotels.length > 0 ? (

                        <div
                            className="
                                grid
                                gap-5

                                sm:grid-cols-2

                                xl:grid-cols-3
                            "
                        >

                            {hotels.map((hotel, index) => {

                                const cleanDescription =
                                    hotel.short_description
                                        ?.replace(/<[^>]*>/g, "")
                                        ?.trim() ||
                                    "Enjoy a comfortable stay with convenient access to Dubai's attractions.";

                                const price = Math.round(
                                    Number(hotel.price_per_night || 0)
                                );

                                return (

                                    <article
                                        key={hotel.id}
                                        onClick={() =>
                                            navigate(`/hotels/${hotel.slug}`)
                                        }
                                        className="
                                            group
                                            cursor-pointer
                                            overflow-hidden
                                            rounded-[20px]
                                            border
                                            border-[#DED8CC]
                                            bg-[#FBFAF6]
                                            shadow-[0_8px_30px_rgba(15,45,44,0.055)]
                                            transition-all
                                            duration-500
                                            hover:-translate-y-1.5
                                            hover:shadow-[0_18px_45px_rgba(15,45,44,0.12)]
                                        "
                                    >

                                        {/* =================================================
                                            IMAGE
                                        ================================================= */}

                                        <div
                                            className="
                                                relative
                                                h-[245px]
                                                overflow-hidden
                                            "
                                        >

                                            <img
                                                src={`https://uaediscountedhotels.com/uploads/hotels/${hotel.image}`}
                                                alt={hotel.name}
                                                className="
                                                    h-full
                                                    w-full
                                                    object-cover
                                                    transition-transform
                                                    duration-700
                                                    group-hover:scale-105
                                                "
                                            />


                                            {/* IMAGE OVERLAY */}

                                            <div
                                                className="
                                                    absolute
                                                    inset-0
                                                    bg-gradient-to-t
                                                    from-[#073F3D]/90
                                                    via-[#073F3D]/10
                                                    to-transparent
                                                "
                                            />


                                            {/* NUMBER */}

                                            <div
                                                className="
                                                    absolute
                                                    left-4
                                                    top-4
                                                    flex
                                                    h-8
                                                    w-8
                                                    items-center
                                                    justify-center
                                                    rounded-full
                                                    border
                                                    border-white/20
                                                    bg-[#073F3D]/80
                                                    text-[10px]
                                                    font-bold
                                                    text-[#E5C56D]
                                                    backdrop-blur-md
                                                "
                                            >
                                                {String(index + 1).padStart(
                                                    2,
                                                    "0"
                                                )}
                                            </div>


                                            {/* LOCATION */}

                                            <div className="absolute right-4 top-4">

                                                <div
                                                    className="
                                                        flex
                                                        items-center
                                                        gap-1.5
                                                        rounded-full
                                                        border
                                                        border-white/20
                                                        bg-[#073F3D]/70
                                                        px-3
                                                        py-1.5
                                                        text-[9px]
                                                        font-semibold
                                                        text-white
                                                        backdrop-blur-md
                                                    "
                                                >
                                                    <FaMapMarkerAlt className="text-[9px] text-[#E5C56D]" />

                                                    {destination.name}
                                                </div>

                                            </div>


                                            {/* IMAGE CONTENT */}

                                            <div
                                                className="
                                                    absolute
                                                    bottom-0
                                                    left-0
                                                    right-0
                                                    p-5
                                                "
                                            >

                                                <div className="mb-2 flex items-center gap-1">

                                                    {[1, 2, 3, 4, 5].map(
                                                        (star) => (
                                                            <FaStar
                                                                key={star}
                                                                className="
                                                                    text-[9px]
                                                                    text-[#E5C56D]
                                                                "
                                                            />
                                                        )
                                                    )}

                                                    <span
                                                        className="
                                                            ml-1
                                                            text-[9px]
                                                            font-medium
                                                            text-white/70
                                                        "
                                                    >
                                                        Hotel
                                                    </span>

                                                </div>

                                                <h3
                                                    className="
                                                        line-clamp-1
                                                        font-serif
                                                        text-[21px]
                                                        font-medium
                                                        text-white
                                                    "
                                                >
                                                    {hotel.name}
                                                </h3>

                                            </div>

                                        </div>


                                        {/* =================================================
                                            CARD CONTENT
                                        ================================================= */}

                                        <div className="p-5">

                                            <p
                                                className="
                                                    line-clamp-2
                                                    min-h-[44px]
                                                    text-[11px]
                                                    leading-5
                                                    text-[#687572]
                                                "
                                            >
                                                {cleanDescription}
                                            </p>


                                            {/* INFO */}

                                            <div className="mt-5 grid grid-cols-2 gap-3">

                                                {/* LOCATION */}

                                                <div
                                                    className="
                                                        rounded-xl
                                                        border
                                                        border-[#DED8CC]
                                                        bg-[#F3EBDD]/60
                                                        p-3
                                                    "
                                                >

                                                    <p
                                                        className="
                                                            text-[8px]
                                                            font-bold
                                                            uppercase
                                                            tracking-[0.14em]
                                                            text-[#89928F]
                                                        "
                                                    >
                                                        Location
                                                    </p>

                                                    <div
                                                        className="
                                                            mt-1.5
                                                            flex
                                                            items-center
                                                            gap-1.5
                                                            text-[10px]
                                                            font-bold
                                                            text-[#0B5552]
                                                        "
                                                    >
                                                        <FaMapMarkerAlt />

                                                        <span className="truncate">
                                                            {destination.name}
                                                        </span>
                                                    </div>

                                                </div>


                                                {/* PRICE */}

                                                <div
                                                    className="
                                                        rounded-xl
                                                        border
                                                        border-[#D5A33C]/25
                                                        bg-[#F3EBDD]
                                                        p-3
                                                    "
                                                >

                                                    <p
                                                        className="
                                                            text-[8px]
                                                            font-bold
                                                            uppercase
                                                            tracking-[0.14em]
                                                            text-[#89928F]
                                                        "
                                                    >
                                                        Starting From
                                                    </p>

                                                    <p
                                                        className="
                                                            mt-1
                                                            font-serif
                                                            text-[17px]
                                                            font-medium
                                                            text-[#173F3E]
                                                        "
                                                    >
                                                        {price.toLocaleString()}{" "}

                                                        <span
                                                            className="
                                                                font-sans
                                                                text-[8px]
                                                                font-semibold
                                                                text-[#B78932]
                                                            "
                                                        >
                                                            AED
                                                        </span>
                                                    </p>

                                                </div>

                                            </div>


                                            {/* CTA */}

                                            <div
                                                className="
                                                    mt-5
                                                    flex
                                                    items-center
                                                    justify-between
                                                    border-t
                                                    border-[#DED8CC]
                                                    pt-4
                                                "
                                            >

                                                <span
                                                    className="
                                                        text-[10px]
                                                        font-medium
                                                        text-[#89928F]
                                                    "
                                                >
                                                    View hotel details
                                                </span>

                                                <div
                                                    className="
                                                        flex
                                                        h-9
                                                        w-9
                                                        items-center
                                                        justify-center
                                                        rounded-full
                                                        bg-[#0B5552]
                                                        text-white
                                                        transition-all
                                                        duration-300
                                                        group-hover:bg-[#D5A33C]
                                                        group-hover:text-[#173F3E]
                                                    "
                                                >
                                                    <FaArrowRight
                                                        className="
                                                            text-[11px]
                                                            transition-transform
                                                            duration-300
                                                            group-hover:translate-x-0.5
                                                        "
                                                    />
                                                </div>

                                            </div>

                                        </div>


                                        {/* GOLD HOVER LINE */}

                                        <div
                                            className="
                                                h-[2px]
                                                w-0
                                                bg-[#D5A33C]
                                                transition-all
                                                duration-500
                                                group-hover:w-full
                                            "
                                        />

                                    </article>

                                );
                            })}

                        </div>

                    ) : (

                        /* =================================================
                           EMPTY STATE
                        ================================================= */

                        <div
                            className="
                                rounded-[22px]
                                border
                                border-dashed
                                border-[#DED8CC]
                                bg-[#FBFAF6]
                                px-6
                                py-20
                                text-center
                            "
                        >

                            <div
                                className="
                                    mx-auto
                                    flex
                                    h-20
                                    w-20
                                    items-center
                                    justify-center
                                    rounded-full
                                    border
                                    border-[#D5A33C]/30
                                    bg-[#F3EBDD]
                                "
                            >
                                <FaHotel className="text-2xl text-[#0B5552]" />
                            </div>

                            <div
                                className="
                                    mx-auto
                                    mt-6
                                    flex
                                    items-center
                                    justify-center
                                    gap-3
                                "
                            >
                                <span className="h-px w-7 bg-[#D5A33C]" />

                                <span
                                    className="
                                        text-[9px]
                                        font-semibold
                                        uppercase
                                        tracking-[0.2em]
                                        text-[#0B5552]
                                    "
                                >
                                    Hotel Collection
                                </span>

                                <span className="h-px w-7 bg-[#D5A33C]" />
                            </div>

                            <h3
                                className="
                                    mt-4
                                    font-serif
                                    text-[29px]
                                    font-medium
                                    text-[#173F3E]
                                "
                            >
                                No Hotels Found
                            </h3>

                            <p
                                className="
                                    mx-auto
                                    mt-3
                                    max-w-md
                                    text-[12px]
                                    leading-6
                                    text-[#687572]
                                "
                            >
                                There are currently no hotels available in{" "}
                                {destination.name}. Explore other destinations
                                to find your perfect stay.
                            </p>

                            <button
                                onClick={() => navigate("/destinations")}
                                className="
                                    mt-7
                                    inline-flex
                                    items-center
                                    gap-2
                                    rounded-xl
                                    bg-[#0B5552]
                                    px-6
                                    py-3.5
                                    text-[11px]
                                    font-bold
                                    text-white
                                    transition-all
                                    duration-300
                                    hover:-translate-y-0.5
                                    hover:bg-[#073F3D]
                                "
                            >
                                Browse Destinations
                                <FaArrowRight className="text-[10px]" />
                            </button>

                        </div>

                    )}

                </div>

            </section>


            {/* =====================================================
                DESTINATION CTA
            ===================================================== */}

            <section
                className="
                    px-5
                    pb-16

                    sm:px-8

                    lg:px-12
                    lg:pb-20

                    xl:px-16
                "
            >

                <div
                    className="
                        relative
                        mx-auto
                        max-w-[1440px]
                        overflow-hidden
                        rounded-[24px]
                        bg-[#073F3D]
                        px-6
                        py-12

                        sm:px-10

                        md:px-14

                        lg:py-16
                    "
                >

                    {/* DECORATION */}

                    <div
                        className="
                            pointer-events-none
                            absolute
                            -right-20
                            -top-20
                            h-64
                            w-64
                            rounded-full
                            bg-[#0B5552]
                            opacity-70
                            blur-3xl
                        "
                    />

                    <div
                        className="
                            pointer-events-none
                            absolute
                            -bottom-24
                            left-1/3
                            h-64
                            w-64
                            rounded-full
                            bg-[#D5A33C]
                            opacity-10
                            blur-3xl
                        "
                    />


                    {/* GOLD TOP LINE */}

                    <div
                        className="
                            absolute
                            left-0
                            top-0
                            h-[2px]
                            w-full
                            bg-[#D5A33C]
                        "
                    />


                    {/* CONTENT */}

                    <div
                        className="
                            relative
                            z-10
                            flex
                            flex-col
                            items-start
                            justify-between
                            gap-8

                            lg:flex-row
                            lg:items-center
                        "
                    >

                        <div className="max-w-2xl">

                            <div
                                className="
                                    flex
                                    items-center
                                    gap-3
                                "
                            >
                                <span className="h-px w-7 bg-[#D5A33C]" />

                                <p
                                    className="
                                        text-[9px]
                                        font-semibold
                                        uppercase
                                        tracking-[0.22em]
                                        text-[#E5C56D]
                                    "
                                >
                                    Your Dubai Stay Awaits
                                </p>
                            </div>

                            <h2
                                className="
                                    mt-4
                                    font-serif
                                    text-[30px]
                                    font-medium
                                    leading-[1.08]
                                    tracking-[-0.02em]
                                    !text-white

                                    sm:text-[38px]

                                    lg:text-[42px]
                                "
                            >
                                Ready to Explore{" "}
                                <span className="italic text-[#E5C56D]">
                                    {destination.name}?
                                </span>
                            </h2>

                            <p
                                className="
                                    mt-4
                                    max-w-xl
                                    text-[12px]
                                    leading-6
                                    text-white/60

                                    sm:text-[13px]
                                "
                            >
                                Find the right hotel for your Dubai trip and
                                enjoy a simple, trusted booking experience.
                            </p>

                        </div>


                        {/* BUTTONS */}

                        <div
                            className="
                                flex
                                w-full
                                flex-col
                                gap-3

                                sm:w-auto
                                sm:flex-row
                            "
                        >

                            <button
                                onClick={() => navigate("/hotels")}
                                className="
                                    inline-flex
                                    items-center
                                    justify-center
                                    gap-2
                                    rounded-xl
                                    bg-[#D5A33C]
                                    px-6
                                    py-3.5
                                    text-[11px]
                                    font-bold
                                    text-[#173F3E]
                                    shadow-[0_10px_25px_rgba(0,0,0,0.12)]
                                    transition-all
                                    duration-300
                                    hover:-translate-y-0.5
                                    hover:bg-[#E5C56D]
                                "
                            >
                                Explore All Hotels
                                <FaArrowRight className="text-[10px]" />
                            </button>

                            <button
                                onClick={() => navigate("/destinations")}
                                className="
                                    inline-flex
                                    items-center
                                    justify-center
                                    gap-2
                                    rounded-xl
                                    border
                                    border-white/15
                                    bg-white/5
                                    px-6
                                    py-3.5
                                    text-[11px]
                                    font-semibold
                                    text-white
                                    backdrop-blur-sm
                                    transition-all
                                    duration-300
                                    hover:bg-white/10
                                "
                            >
                                More Destinations
                            </button>

                        </div>

                    </div>

                </div>

            </section>

        </div>
    );
}